import { NavLink } from "react-router-dom";
import "./TabsItem.scss";
export default (props) => {
  return (
    <li className={`Tabs__item` }>
      <NavLink exact {...props} className={`Tabs__lnik` }>
        {props.children}
      </NavLink>
    </li>
  );
};
